import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchEmployeePayroll,
  fetchEmployeePayrollNotifications,
  fetchGymOverviewDetailsStats,
  fetchGymOverviewStats,
  fetchPayroleDiscrepancy,
  fetchPayroleHistory,
  fetchPayrollDetail,
  fetchRoasterMonthly,
  fetchRoasterWeekly,
  fetchStaffPayroleDiscrepancy,
  fetchDraftPayroll,
  fetchRoasterStats,
  fetchAvilableTrainersRoaster,
  fetchAvilableFDRoaster,
  fetchAvilableTrainerFDRoaster,
  fetchGeneratedRoaster,
  fetchStaffWeekoffRoaster,
  fetchAssignedStaff,
  fetchIncentivePercentage,
  fetchTrainerIncentiveById,
} from "./payroleApis";

export const fetchEmployeePayrollData = createAsyncThunk(
  "payrole/fetchEmployeePayrollData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchEmployeePayroll(filters, token);
    return response;
  }
);

export const fetchStaffPayroleDiscrepancyData = createAsyncThunk(
  "payrole/fetchStaffPayroleDiscrepancyData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffPayroleDiscrepancy(filters, token);
    return response;
  }
);

export const fetchPayroleDiscrepancyData = createAsyncThunk(
  "payrole/fetchPayroleDiscrepancyData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPayroleDiscrepancy(filters, token);
    return response;
  }
);

export const fetchGymOverviewStatsData = createAsyncThunk(
  "payrole/fetchGymOverviewStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymOverviewStats(filters, token);
    return response;
  }
);

export const fetchGymOverviewDetailsStatsData = createAsyncThunk(
  "payrole/fetchGymOverviewDetailsStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGymOverviewDetailsStats(filters, token);
    return response;
  }
);

export const fetchEmployeePayrollNotificationsData = createAsyncThunk(
  "payrole/fetchEmployeePayrollNotificationsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchEmployeePayrollNotifications(filters, token);
    return response;
  }
);

export const fetchPayrollDetailData = createAsyncThunk(
  "payrole/fetchPayrollDetailData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPayrollDetail(filters, token);
    return response;
  }
);

export const fetchPayroleHistoryData = createAsyncThunk(
  "payrole/fetchPayroleHistoryData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchPayroleHistory(filters, token);
    return response;
  }
);

export const fetchRoasterMonthlyData = createAsyncThunk(
  "payrole/fetchRoasterMonthlyData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRoasterMonthly(filters, token);
    return response;
  }
);

export const fetchRoasterWeeklyData = createAsyncThunk(
  "payrole/fetchRoasterWeeklyData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRoasterWeekly(filters, token);
    return response;
  }
);

export const fetchRoasterStatsData = createAsyncThunk(
  "payrole/fetchRoasterStatsData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchRoasterStats(filters, token);
    return response;
  }
);

export const fetchAvilableTrainersRoasterData = createAsyncThunk(
  "payrole/fetchAvilableTrainersRoasterData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAvilableTrainersRoaster(filters, token);
    return response;
  }
);

export const fetchAvilableFDRoasterData = createAsyncThunk(
  "payrole/fetchAvilableFDRoasterData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAvilableFDRoaster(filters, token);
    return response;
  }
);

export const fetchAvilableTrainerFDRoasterData = createAsyncThunk(
  "payrole/fetchAvilableTrainerFDRoasterData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAvilableTrainerFDRoaster(filters, token);
    return response;
  }
);

export const fetchGeneratedRoasterData = createAsyncThunk(
  "payrole/fetchGeneratedRoasterData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchGeneratedRoaster(filters, token);
    return response;
  }
);

export const fetchStaffWeekoffRoasterData = createAsyncThunk(
  "payrole/fetchStaffWeekoffRoasterData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchStaffWeekoffRoaster(filters, token);
    return response;
  }
);

export const fetchAssignedStaffData = createAsyncThunk(
  "payrole/fetchAssignedStaffData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchAssignedStaff(filters, token);
    return response;
  }
);

export const fetchDraftPayrollData = createAsyncThunk(
  "payrole/fetchDraftPayrollData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchDraftPayroll(filters, token);
    return response;
  }
);

export const fetchIncentivePercentageData = createAsyncThunk(
  "payrole/fetchIncentivePercentageData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchIncentivePercentage(filters, token);
    return response;
  }
);

export const fetchTrainerIncentiveByIdData = createAsyncThunk(
  "payrole/fetchTrainerIncentiveByIdData",
  async (payload, { getState }) => {
    const { filters, token } = payload;
    const response = await fetchTrainerIncentiveById(filters, token);
    return response;
  }
);

const payroleSlice = createSlice({
  name: "payrole",
  initialState: {
    employeePayrollData: null,
    employeePayrollLoading: false,
    employeePayrollError: null,

    staffPayroleDiscrepancyData: null,
    staffPayroleDiscrepancyLoading: false,
    staffPayroleDiscrepancyError: null,

    payroleDiscrepancyData: null,
    payroleDiscrepancyLoading: false,
    payroleDiscrepancyError: null,

    gymOverviewStatsData: null,
    gymOverviewStatsLoading: false,
    gymOverviewStatsError: null,

    gymOverviewDetailsStatsData: null,
    gymOverviewDetailsStatsLoading: false,
    gymOverviewDetailsStatsError: null,

    employeePayrollNotificationsData: null,
    employeePayrollNotificationsLoading: false,
    employeePayrollNotificationsError: null,

    payrollDetailData: null,
    payrollDetailLoading: false,
    payrollDetailError: null,

    payroleHistoryData: null,
    payroleHistoryLoading: false,
    payroleHistoryError: null,

    generateRosterLoading: false,
    generateRosterError: null,
    generateRosterResult: null,

    rosterStatsData: null,
    rosterStatsLoading: false,
    rosterStatsError: null,

    getTrainersWithAltShiftLoading: false,
    getTrainersWithAltShiftData: null,
    getTrainersWithAltShiftError: null,

    getReceptionistsWithAltShiftLoading: false,
    getReceptionistsWithAltShiftData: null,
    getReceptionistsWithAltShiftError: null,

    getTrainerAndFdsWithAltShiftLoading: false,
    getTrainerAndFdsWithAltShiftData: null,
    getTrainerAndFdsWithAltShiftError: null,

    generatedRoasterData: null,
    generatedRoasterLoading: false,
    generatedRoasterError: null,

    staffWeekoffRoasterData: null,
    staffWeekoffRoasterLoading: false,
    staffWeekoffRoasterError: null,

    assignedStaffData: null,
    assignedStaffLoading: false,
    assignedStaffError: null,

    draftPayrollData: null,
    draftPayrollLoading: false,
    draftPayrollError: null,

    roasterMonthlyData: null,
    roasterMonthlyLoading: false,
    roasterMonthlyError: null,

    roasterWeeklyData: null,
    roasterWeeklyLoading: false,
    roasterWeeklyError: null,

    incentivePercentageData: null,
    incentivePercentageLoading: false,
    incentivePercentageError: null,

    trainerIncentiveByIdData: null,
    trainerIncentiveByIdLoading: false,
    trainerIncentiveByIdError: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeePayrollData.pending, (state) => {
        state.employeePayrollLoading = true;
        state.employeePayrollData = null;
        state.employeePayrollError = null;
      })
      .addCase(fetchEmployeePayrollData.fulfilled, (state, action) => {
        state.employeePayrollLoading = false;
        state.employeePayrollData = action.payload;
        state.employeePayrollError = null;
      })
      .addCase(fetchEmployeePayrollData.rejected, (state, action) => {
        state.employeePayrollLoading = false;
        state.employeePayrollData = null;
        state.employeePayrollError = action.error.message;
      })

      .addCase(fetchStaffPayroleDiscrepancyData.pending, (state) => {
        state.staffPayroleDiscrepancyLoading = true;
        state.staffPayroleDiscrepancyData = null;
        state.staffPayroleDiscrepancyError = null;
      })
      .addCase(fetchStaffPayroleDiscrepancyData.fulfilled, (state, action) => {
        state.staffPayroleDiscrepancyLoading = false;
        state.staffPayroleDiscrepancyData = action.payload;
        state.staffPayroleDiscrepancyError = null;
      })
      .addCase(fetchStaffPayroleDiscrepancyData.rejected, (state, action) => {
        state.staffPayroleDiscrepancyLoading = false;
        state.staffPayroleDiscrepancyData = null;
        state.staffPayroleDiscrepancyError = action.error.message;
      })

      .addCase(fetchPayroleDiscrepancyData.pending, (state) => {
        state.payroleDiscrepancyLoading = true;
        state.payroleDiscrepancyData = null;
        state.payroleDiscrepancyError = null;
      })
      .addCase(fetchPayroleDiscrepancyData.fulfilled, (state, action) => {
        state.payroleDiscrepancyLoading = false;
        state.payroleDiscrepancyData = action.payload;
        state.payroleDiscrepancyError = null;
      })
      .addCase(fetchPayroleDiscrepancyData.rejected, (state, action) => {
        state.payroleDiscrepancyLoading = false;
        state.payroleDiscrepancyData = null;
        state.payroleDiscrepancyError = action.error.message;
      })

      .addCase(fetchGymOverviewStatsData.pending, (state) => {
        state.gymOverviewStatsLoading = true;
        state.gymOverviewStatsData = null;
        state.gymOverviewStatsError = null;
      })
      .addCase(fetchGymOverviewStatsData.fulfilled, (state, action) => {
        state.gymOverviewStatsLoading = false;
        state.gymOverviewStatsData = action.payload;
        state.gymOverviewStatsError = null;
      })
      .addCase(fetchGymOverviewStatsData.rejected, (state, action) => {
        state.gymOverviewStatsLoading = false;
        state.gymOverviewStatsData = null;
        state.gymOverviewStatsError = action.error.message;
      })

      .addCase(fetchGymOverviewDetailsStatsData.pending, (state) => {
        state.gymOverviewDetailsStatsLoading = true;
        state.gymOverviewDetailsStatsData = null;
        state.gymOverviewDetailsStatsError = null;
      })
      .addCase(fetchGymOverviewDetailsStatsData.fulfilled, (state, action) => {
        state.gymOverviewDetailsStatsLoading = false;
        state.gymOverviewDetailsStatsData = action.payload;
        state.gymOverviewDetailsStatsError = null;
      })
      .addCase(fetchGymOverviewDetailsStatsData.rejected, (state, action) => {
        state.gymOverviewDetailsStatsLoading = false;
        state.gymOverviewDetailsStatsData = null;
        state.gymOverviewDetailsStatsError = action.error.message;
      })

      .addCase(fetchEmployeePayrollNotificationsData.pending, (state) => {
        state.employeePayrollNotificationsLoading = true;
        state.employeePayrollNotificationsData = null;
        state.employeePayrollNotificationsError = null;
      })
      .addCase(
        fetchEmployeePayrollNotificationsData.fulfilled,
        (state, action) => {
          state.employeePayrollNotificationsLoading = false;
          state.employeePayrollNotificationsData = action.payload;
          state.employeePayrollNotificationsError = null;
        }
      )
      .addCase(
        fetchEmployeePayrollNotificationsData.rejected,
        (state, action) => {
          state.employeePayrollNotificationsLoading = false;
          state.employeePayrollNotificationsData = null;
          state.employeePayrollNotificationsError = action.error.message;
        }
      )

      .addCase(fetchPayrollDetailData.pending, (state) => {
        state.payrollDetailLoading = true;
        state.payrollDetailData = null;
        state.payrollDetailError = null;
      })
      .addCase(fetchPayrollDetailData.fulfilled, (state, action) => {
        state.payrollDetailLoading = false;
        state.payrollDetailData = action.payload;
        state.payrollDetailError = null;
      })
      .addCase(fetchPayrollDetailData.rejected, (state, action) => {
        state.payrollDetailLoading = false;
        state.payrollDetailData = null;
        state.payrollDetailError = action.error.message;
      })

      .addCase(fetchPayroleHistoryData.pending, (state) => {
        state.payroleHistoryLoading = true;
        state.payroleHistoryData = null;
        state.payroleHistoryError = null;
      })
      .addCase(fetchPayroleHistoryData.fulfilled, (state, action) => {
        state.payroleHistoryLoading = false;
        state.payroleHistoryData = action.payload;
        state.payroleHistoryError = null;
      })
      .addCase(fetchPayroleHistoryData.rejected, (state, action) => {
        state.payroleHistoryLoading = false;
        state.payroleHistoryData = null;
        state.payroleHistoryError = action.error.message;
      })

      .addCase(fetchRoasterStatsData.pending, (state) => {
        state.rosterStatsLoading = true;
        state.rosterStatsData = null;
        state.rosterStatsError = null;
      })
      .addCase(fetchRoasterStatsData.fulfilled, (state, action) => {
        state.rosterStatsLoading = false;
        state.rosterStatsData = action.payload;
        state.rosterStatsError = null;
      })
      .addCase(fetchRoasterStatsData.rejected, (state, action) => {
        state.rosterStatsLoading = false;
        state.rosterStatsData = null;
        state.rosterStatsError = action.error.message;
      })

      .addCase(fetchAvilableTrainersRoasterData.pending, (state) => {
        state.getTrainersWithAltShiftLoading = true;
        state.getTrainersWithAltShiftData = null;
        state.getTrainersWithAltShiftError = null;
      })
      .addCase(fetchAvilableTrainersRoasterData.fulfilled, (state, action) => {
        state.getTrainersWithAltShiftLoading = false;
        state.getTrainersWithAltShiftData = action.payload;
        state.getTrainersWithAltShiftError = null;
      })
      .addCase(fetchAvilableTrainersRoasterData.rejected, (state, action) => {
        state.getTrainersWithAltShiftLoading = false;
        state.getTrainersWithAltShiftData = null;
        state.getTrainersWithAltShiftError = action.error.message;
      })

      .addCase(fetchAvilableFDRoasterData.pending, (state) => {
        state.getReceptionistsWithAltShiftLoading = true;
        state.getReceptionistsWithAltShiftData = null;
        state.getReceptionistsWithAltShiftError = null;
      })
      .addCase(fetchAvilableFDRoasterData.fulfilled, (state, action) => {
        state.getReceptionistsWithAltShiftLoading = false;
        state.getReceptionistsWithAltShiftData = action.payload;
        state.getReceptionistsWithAltShiftError = null;
      })
      .addCase(fetchAvilableFDRoasterData.rejected, (state, action) => {
        state.getReceptionistsWithAltShiftLoading = false;
        state.getReceptionistsWithAltShiftData = null;
        state.getReceptionistsWithAltShiftError = action.error.message;
      })

      .addCase(fetchAvilableTrainerFDRoasterData.pending, (state) => {
        state.getTrainerAndFdsWithAltShiftLoading = true;
        state.getTrainerAndFdsWithAltShiftData = null;
        state.getTrainerAndFdsWithAltShiftError = null;
      })
      .addCase(fetchAvilableTrainerFDRoasterData.fulfilled, (state, action) => {
        state.getTrainerAndFdsWithAltShiftLoading = false;
        state.getTrainerAndFdsWithAltShiftData = action.payload;
        state.getTrainerAndFdsWithAltShiftError = null;
      })
      .addCase(fetchAvilableTrainerFDRoasterData.rejected, (state, action) => {
        state.getTrainerAndFdsWithAltShiftLoading = false;
        state.getTrainerAndFdsWithAltShiftData = null;
        state.getTrainerAndFdsWithAltShiftError = action.error.message;
      })

      .addCase(fetchGeneratedRoasterData.pending, (state) => {
        state.generatedRoasterLoading = true;
        state.generatedRoasterData = null;
        state.generatedRoasterError = null;
      })
      .addCase(fetchGeneratedRoasterData.fulfilled, (state, action) => {
        state.generatedRoasterLoading = false;
        state.generatedRoasterData = action.payload;
        state.generatedRoasterError = null;
      })
      .addCase(fetchGeneratedRoasterData.rejected, (state, action) => {
        state.generatedRoasterLoading = false;
        state.generatedRoasterData = null;
        state.generatedRoasterError = action.error.message;
      })

      .addCase(fetchRoasterMonthlyData.pending, (state) => {
        state.roasterMonthlyLoading = true;
        state.roasterMonthlyData = null;
        state.roasterMonthlyError = null;
      })
      .addCase(fetchRoasterMonthlyData.fulfilled, (state, action) => {
        state.roasterMonthlyLoading = false;
        state.roasterMonthlyData = action.payload;
        state.roasterMonthlyError = null;
      })
      .addCase(fetchRoasterMonthlyData.rejected, (state, action) => {
        state.roasterMonthlyLoading = false;
        state.roasterMonthlyData = null;
        state.roasterMonthlyError = action.error.message;
      })

      .addCase(fetchRoasterWeeklyData.pending, (state) => {
        state.roasterWeeklyLoading = true;
        state.roasterWeeklyData = null;
        state.roasterWeeklyError = null;
      })
      .addCase(fetchRoasterWeeklyData.fulfilled, (state, action) => {
        state.roasterWeeklyLoading = false;
        state.roasterWeeklyData = action.payload;
        state.roasterWeeklyError = null;
      })
      .addCase(fetchRoasterWeeklyData.rejected, (state, action) => {
        state.roasterWeeklyLoading = false;
        state.roasterWeeklyData = null;
        state.roasterWeeklyError = action.error.message;
      })

      .addCase(fetchDraftPayrollData.pending, (state) => {
        state.draftPayrollLoading = true;
        state.draftPayrollData = null;
        state.draftPayrollError = null;
      })
      .addCase(fetchDraftPayrollData.fulfilled, (state, action) => {
        state.draftPayrollLoading = false;
        state.draftPayrollData = action.payload;
        state.draftPayrollError = null;
      })
      .addCase(fetchDraftPayrollData.rejected, (state, action) => {
        state.draftPayrollLoading = false;
        state.draftPayrollData = null;
        state.draftPayrollError = action.error.message;
      })

      .addCase(fetchStaffWeekoffRoasterData.pending, (state) => {
        state.staffWeekoffRoasterLoading = true;
        state.staffWeekoffRoasterData = null;
        state.staffWeekoffRoasterError = null;
      })
      .addCase(fetchStaffWeekoffRoasterData.fulfilled, (state, action) => {
        state.staffWeekoffRoasterLoading = false;
        state.staffWeekoffRoasterData = action.payload;
        state.staffWeekoffRoasterError = null;
      })
      .addCase(fetchStaffWeekoffRoasterData.rejected, (state, action) => {
        state.staffWeekoffRoasterLoading = false;
        state.staffWeekoffRoasterData = null;
        state.staffWeekoffRoasterError = action.error.message;
      })

      .addCase(fetchAssignedStaffData.pending, (state) => {
        state.assignedStaffLoading = true;
        state.assignedStaffData = null;
        state.assignedStaffError = null;
      })
      .addCase(fetchAssignedStaffData.fulfilled, (state, action) => {
        state.assignedStaffLoading = false;
        state.assignedStaffData = action.payload;
        state.assignedStaffError = null;
      })
      .addCase(fetchAssignedStaffData.rejected, (state, action) => {
        state.assignedStaffLoading = false;
        state.assignedStaffData = null;
        state.assignedStaffError = action.error.message;
      })

      .addCase(fetchIncentivePercentageData.pending, (state) => {
        state.incentivePercentageLoading = true;
        state.incentivePercentageData = null;
        state.incentivePercentageError = null;
      })
      .addCase(fetchIncentivePercentageData.fulfilled, (state, action) => {
        state.incentivePercentageLoading = false;
        state.incentivePercentageData = action.payload;
        state.incentivePercentageError = null;
      })
      .addCase(fetchIncentivePercentageData.rejected, (state, action) => {
        state.incentivePercentageLoading = false;
        state.incentivePercentageData = null;
        state.incentivePercentageError = action.error.message;
      })

      .addCase(fetchTrainerIncentiveByIdData.pending, (state) => {
        state.trainerIncentiveByIdLoading = true;
        state.trainerIncentiveByIdData = null;
        state.trainerIncentiveByIdError = null;
      })
      .addCase(fetchTrainerIncentiveByIdData.fulfilled, (state, action) => {
        state.trainerIncentiveByIdLoading = false;
        state.trainerIncentiveByIdData = action.payload;
        state.trainerIncentiveByIdError = null;
      })
      .addCase(fetchTrainerIncentiveByIdData.rejected, (state, action) => {
        state.trainerIncentiveByIdLoading = false;
        state.trainerIncentiveByIdData = null;
        state.trainerIncentiveByIdError = action.error.message;
      });
  },
});

export default payroleSlice.reducer;
